module.exports = __webpack_public_path__ + "img/45_17.396fa69b.png";